import { createContext } from "react";

const MarksInputContext = createContext();

export default MarksInputContext;